<template>
  <v-row justify="center">
    <v-col
      cols="12"
      md="9">
      <p class="_fs-20">
        ข้อมูลร้านค้า หรือบริษัท
      </p>
      <div>
        ประเภทผู้เสียภาษี
        <span class="d-block d-md-inline-block primary--text font-weight-bold">
          {{ customerTypeText }}
        </span>
      </div>
      <div v-if="isJuristicCustomer">
        เลขที่สาขา
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ branchNumber }}
          <template v-if="isHeadquarter">
            (สำนักงานใหญ่)
          </template>
        </span>
      </div>
      <div>
        {{ citizenIdText }}
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ citizenId }}
        </span>
      </div>
      <div>
        ชื่อร้านค้าหรือบริษัท
        <span class="d-block d-md-inline-block font-weight-bold">
          {{ companyName }}
        </span>
      </div>

      <p class="mt-4 _fs-20">
        ข้อมูลร้านค้า หรือบริษัท
      </p>
      <v-row no-gutters>
        <v-col cols="6">
          ชื่อ
          <span class="d-block d-md-inline-block font-weight-bold">{{ firstName }}</span>
        </v-col>
        <v-col cols="6">
          นามสกุล
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ lastName }}
          </span>
        </v-col>
        <v-col cols="6">
          Email สำหรับส่งใบกำกับภาษี
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ email }}
          </span>
        </v-col>
        <v-col cols="6">
          Email สำหรับส่งใบเสนอราคา
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ emailQuotation }}
          </span>
        </v-col>
        <v-col cols="6">
          โทรศัพท์
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ tel }}
          </span>
        </v-col>
      </v-row>

      <p class="mt-4 _fs-20">
        ที่อยู่ของร้านค้า หรือบริษัท
      </p>
      <v-row no-gutters>
        <v-col cols="12">
          ที่อยู่
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ address }}
          </span>
        </v-col>
        <v-col cols="6">
          ถนน
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ street || '-' }}
          </span>
        </v-col>
        <v-col cols="6">
          แขวง/ตำบล
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ subdistrict }}
          </span>
        </v-col>
        <v-col cols="6">
          เขต/อำเภอ
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ district }}
          </span>
        </v-col>
        <v-col cols="6">
          จังหวัด
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ stateProvince }}
          </span>
        </v-col>
        <v-col cols="6">
          รหัสไปรษณีย์
          <span class="d-block d-md-inline-block font-weight-bold">
            {{ zipCode }}
          </span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'BaseUserProfileTemplate',
  props: {
    customerTypeText: {
      type: String,
      default: ''
    },
    branchNumber: {
      type: String,
      default: ''
    },
    citizenIdText: {
      type: String,
      default: ''
    },
    citizenId: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    },
    isJuristicCustomer: {
      type: Boolean,
      default: false
    },
    isHeadquarter: {
      type: Boolean,
      default: false
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    emailQuotation: {
      type: String,
      default: ''
    },
    tel: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    street: {
      type: String,
      default: ''
    },
    subdistrict: {
      type: String,
      default: ''
    },
    district: {
      type: String,
      default: ''
    },
    stateProvince: {
      type: String,
      default: ''
    },
    zipCode: {
      type: String,
      default: ''
    }
  }
}
</script>
